/**
 * The two versions of the product, chosen per account (`users.market`):
 *  - `main`: the main market. No typhoon, dengue or seasonal content anywhere,
 *    and US/global crisis lines.
 *  - `ph`: Leena's List Philippines. Season cards, PH crisis lines, pesos.
 * The values mirror the CHECK constraints in migrations/0018_v2_accounts.sql.
 */
export const MARKETS = ["main", "ph"] as const;
export type Market = (typeof MARKETS)[number];

/** The PH-market cities a family can pick (users.ph_region). */
export const PH_REGIONS = [
  "Metro Manila",
  "Cebu City",
  "Davao City",
  "Tacloban City",
  "Iloilo City",
  "Baguio City",
] as const;
export type PhRegion = (typeof PH_REGIONS)[number];
